import 'clndr';
import moment from 'moment';

import BaseComponent from './BaseComponent';

import UrlHelper from "../Helper/Url";
import LayoutHelper from "../Helper/Layout";
import PseudoHelper from "../Helper/Pseudo";

export default class CalendarComponent extends BaseComponent
{
    constructor() {
        super();

        if( $('div.blb-calendar-widget').length < 1 ) {
            this._exists = false;
            return;
        }
        this._exists = true;

        this._dateFormat = 'YYYY-MM-DD';

        this._listItems = Array.from($('li.blb-news-list-item'));

        this.buildFilterRulesFromURL();
        this.restoreFilter();
        this.initWidget();
         

        this._bindListener( 'click', this._onToggleClick, 'ul.blb-news-list-calendar > li.blb-news-list-item button.blb-news-item-trigger' );
        this._bindListener( 'change', this._onCategorySelect, '#blb-news-category-list input[type="checkbox"]' );
    }

    exists() {
        return this._exists;
    }

    initWidget() {
        if( !this._exists ) return;

        let el      = $('div.blb-calendar-widget').first(),
            days    = moment.weekdaysMin();

        days.push( days.shift() ); // Move 'So' to the end

        // ToDo: Move relevant parts of this config elsewhere, maybe a config file...
        $.get( '/typo3conf/ext/blbweb/Resources/Public/Templates/CalendarTemplate.txt', function(d) {
            this._widget = el.clndr({
                template: d,
                moment: moment,
                useTouchEvents: LayoutHelper.isMobile(), // This will use 'touchstart' instead of 'click' if we're in a mobile context
                daysOfTheWeek: days,
                startWithMonth: this._getCalendarStartDate(),
                clickEvents: {
                    // A day is clicked -> Reload page with filter
                    click: (target) => {
                        this._filter.date = target.date.format(this._dateFormat);
                        this.applyFilter();
                    },
                    onMonthChange: () => {
                        this._bindListener( 'click', this._onMonthYearSelect, '.clndr-controls > .month > a' );
                    }
                }
            });

            this.updateNewsList(true);
            this._bindListener( 'click', this._onMonthYearSelect, '.clndr-controls > .month > a' );
        }.bind(this) );

        let url = window.location.href;

        if (url.indexOf('#news-item-') != -1) {
            let id = url.substring(url.indexOf('#news-item-'));

            this._openOnLoad(id);
        }
    }

    _openOnLoad(id) {
        let selector = $(id);
        let isOpen = !selector.hasClass('active');
        let params = { easing: 'linear' };

        for (let i=0; i<this._listItems.length; ++i) {
            let elem = $(this._listItems[i]);

            elem.removeClass('active');
            elem.find('.blb-news-item-body').first().stop().slideUp(params);
        }

        if (isOpen) {
            selector.toggleClass('active');
            selector.find('.blb-news-item-body').first().stop().slideToggle(params);
        }

        setTimeout(() => {
            $('html, body').animate({
                scrollTop: selector.offset().top
            }, 700);
        }, 500);
    }

    restoreFilter() {
        if( typeof this._filter.categories !== 'undefined' ) {
            $('#blb-news-category-list > ul.blb-news-category-list > li.blb-news-category-item input[name="categories[]"]').each(function (i,el) {
                if( _.indexOf( this._filter.categories, $(el).attr('value') ) >= 0 ) {
                    $(el).attr('checked', 'checked');
                }
            }.bind(this));
        }
    }

    applyFilter() {
        document.location = UrlHelper.getUrlWithoutAnchor() + '#' + this._filterToAnchorString();

        this.updateNewsList();
    }

    updateNewsList(firstRun = false) {
        let events = [];

        $('ul.blb-news-list-calendar > li.blb-news-list-item').each( (i, el) => {
            let data = $(el).data();

            if( this._isItemVisible( data ) && $(el).is(':hidden') ) $(el).show();
            if( !this._isItemVisible( data ) && $(el).is(':visible') ) $(el).hide();

            events.push({date: this._dateFromDataArray(data)});
        });

        firstRun && this._widget.addEvents(events);
    }

    buildFilterRulesFromURL(url = document.location.href) {
        try {
            this._filter = JSON.parse( decodeURIComponent(UrlHelper.getAnchor(url)) );
        }
        catch(e) {
            this._filter = {};
        }

        return typeof this._filter === 'object';
    }

    _filterToAnchorString() {
        return encodeURIComponent( JSON.stringify(this._filter) );
    }

    _isItemVisible( data ) {
        let check = true;

        if( check && typeof this._filter.date !== 'undefined' ) {
            check = this._filter.date == this._dateFromDataArray(data);
        }
        if( check && typeof this._filter.year !== 'undefined' ) {
            check = this._filter.year == data.year;
        }
        if( check && typeof this._filter.month !== 'undefined' ) {
            check = this._filter.month == data.month;
        }

        if( check && typeof this._filter.categories !== 'undefined' ) {
            data.categories = data.categories || '';

            // Does the news item have ANY of the categories filtered for?
            check = _.intersection( data.categories.split(','), this._filter.categories ).length > 0;
        }

        return check;
    }

    _getCalendarStartDate() {
        if( typeof this._filter.date !== 'undefined' ) {
            return moment( this._filter.date, this._dateFormat );
        }

        let m = moment();
        m.date(1);

        if( typeof this._filter.year !== 'undefined' ) {
            m.year(this._filter.year);
        }
        if( typeof this._filter.month !== 'undefined' ) {
            m.month(this._filter.month - 1);
        }

        return m.format(this._dateFormat);
    }

    _dateFromDataArray(data) {
        let m = moment();

        m.year(data.year);
        m.month(data.month - 1); // range from 0 - 11
        m.date(data.day);

        return m.format(this._dateFormat);
    }

    _onMonthYearSelect( event ) {
        let data = $(event.currentTarget).data();

        //Remove day selection
        delete this._filter.date;

        // This is a string
        if( typeof data.month !== 'undefined' && data.month.length > 0 ) this._filter.month = moment().month(data.month).format('M');
        // And this an int
        if( typeof data.year !== 'undefined' ) this._filter.year = parseInt(data.year);

        event.preventDefault();
        this.applyFilter();
    }

    _onCategorySelect( event ) {
        this._filter.categories = [];

        $('#blb-news-category-list').serializeArray().forEach((el) => {
            if( el.value.length > 0 ) this._filter.categories.push( el.value );
        });

        if( this._filter.categories.length < 1) delete this._filter.categories;

        this.applyFilter();
    }

    _onToggleClick(e) {
        let btn = e.currentTarget;
        let p = $(btn.parentNode);
        let isOpen = !p.hasClass('active');
        let params = { easing: 'linear' };

        for (let i=0; i<this._listItems.length; ++i) {
            let pElem = $(this._listItems[i]);

            pElem.removeClass('active');
            pElem.find('.blb-news-item-body').first().stop().slideUp(params);
        }

        if (isOpen) {
            p.toggleClass('active');
            p.find('.blb-news-item-body').first().stop().slideToggle(params);
        }
    }
}
